
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/certificaciones",
      function () {
        return require("private-next-pages/certificaciones/index.js");
      }
    ]);
  